import React from "react";
import styles from "./css/index.module.css";
import domainsData from "./data/domains.json";

const EventDetails = () => {
    return (
        <section className={styles.container_wrapper}>
            <div className={styles.container}>
                <div className={styles.left_container}>
                    <div className={styles.heading}>
                        <h1>#CCETC2024</h1>
                    </div>
                    <div className={styles.body}>
                        <p>
                            C3iHub, the Technology Innovation Hub in Cybersecurity at IIT Kanpur, is organizing a Mega Cybersecurity Event at IIT Kanpur to celebrate Cyber Security Awareness Month
                            this October.
                        </p>
                        <div className={styles.event_goals}>
                            <h3>Event Goals:</h3>
                            <ul>
                                <li>Create a platform for R&D, innovation, tech-translation, and product commercialization.</li>
                                <li>Generate a whitepaper on enhancing cyber defense and resilience from panel discussions.</li>
                                <li>Promote Made-in-India cybersecurity products.</li>
                                <li>Develop and improve cybersecurity and cyber threat awareness among attendees.</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className={styles.right_container}>
                    <div className={styles.heading}>
                        <h1>DOMAINS</h1>
                    </div>
                    <div className={styles.body}>
                        <div className={styles.grid}>
                            {domainsData.map((item, index) => (
                                <div key={`${item.name}${index}`} className={styles.grid_item}>
                                    <div className={styles.logo}>
                                        <img src={process.env.REACT_APP_BASE_PATH + item.image} alt={item.name} />
                                    </div>
                                    <h4>{item.name}</h4>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default EventDetails;
